import SearchField from "shared/Search";
import InputSelect from "shared/InputSelect";
import DashboardCard from "shared/DashboardCard";
import { useNavigate } from "react-router-dom";
import { TKIconAddCircle, TKIconFilter } from "assets/images/svgs";
import { useSelector } from "react-redux";
import { useState } from "react";

const Details = ({ setprojectData }) => {
  const navigate = useNavigate();
  const [searchString, setSearchString] = useState("");
  const { projectsCount, projects } = useSelector((state) => state.project);

  const activeProjects = projects?.filter(
    (project) => project.status === "active"
  );
  const closedProjects = projects?.filter(
    (project) => project.status === "archived"
  );
  const pendingProjects = projects?.filter(
    (project) => project.status === "pending"
  );

  const projectsOptions = [
    {
      id: 1,
      title: "All Projects",
      value: "",
    },
    {
      id: 2,
      title: "Active Projects",
      value: "active",
    },
    {
      id: 3,
      title: "Closed Projects",
      value: "archived",
    },
    {
      id: 4,
      title: "Pending Projects",
      value: "pending",
    },
  ];

  const handleNewProject = () => {
    let path = "/ngo/projects/create-project";
    navigate(path);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      setprojectData(
        projects?.filter(
          (data) =>
            data.name.toLowerCase().includes(searchString.toLowerCase()) ||
            data.status.toLowerCase().includes(searchString.toLowerCase()) ||
            data.summary.toLowerCase().includes(searchString.toLowerCase())
        )
      );
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-4 max-[670px]:flex-wrap">
        <DashboardCard
          className="rounded-lg"
          title="Total Projects"
          completedProjects={projectsCount}
          paragraph="since January"
          textColor="text-white"
          paragraphColor="text-[#F0CA18]"
          bgColor="bg-[#011F56]"
          percentage="+0%"
        />
        <DashboardCard
          className="rounded-lg !bg-[#fafafafa]"
          title="Active Projects"
          completedProjects={activeProjects.length}
          paragraph="recent projects"
          paragraphColor="text-[#0ABD06]"
          bgColor="bg-white"
          percentage="5"
        />
        <DashboardCard
          className="rounded-lg !bg-[#fafafafa]"
          title="Closed Projects"
          completedProjects={closedProjects.length}
          paragraph="since January"
          paragraphColor="text-red-500"
          bgColor="bg-white"
          percentage="2"
        />
        <DashboardCard
          className="rounded-lg !bg-[#fafafafa]"
          title="Pending Projects"
          completedProjects={pendingProjects.length}
          paragraph="since January"
          paragraphColor="text-[#0ABD06]"
          bgColor="bg-white"
          percentage="3"
        />
      </div>
      <div className="flex flex-wrap gap-4 justify-between items-center pb-6">
        <div className="flex items-center max-[650px]:flex-wrap gap-4">
          <SearchField
            className="w-full flex"
            placeholder="Search projects"
            onChange={(e) => setSearchString(e.target.value)}
            onKeyDown={handleKeyPress}
          />
          <div className="flex gap-1">
            <TKIconFilter />
            <p className="text-[#7A7A7A] whitespace-nowrap">Filter Projects</p>
          </div>
          <div className="w-[260px] max-[650px]:w-full">
            <InputSelect
              onChange={(e) => {
                if (e.target.value === "") {
                  setprojectData(projects);
                } else {
                  setprojectData(
                    projects?.filter((data) => data.status === e.target.value)
                  );
                }
              }}
              options={projectsOptions}
            />
          </div>
        </div>
        <div
          onClick={handleNewProject}
          className="bg-[#213874] cursor-pointer rounded-md flex items-center py-3 px-6 gap-2 text-white"
        >
          <TKIconAddCircle />
          <p>New Project</p>
        </div>
      </div>
    </div>
  );
};

export default Details;
